"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const SearchApp_vue_1 = __importDefault(require("@/SearchApp/SearchApp.vue"));
const SharedToast_vue_1 = __importDefault(require("@/SharedToastApp/SharedToast.vue"));
const SharedBanner_vue_1 = __importDefault(require("@/SharedBannerApp/SharedBanner.vue"));
const EmarsysToast_vue_1 = __importDefault(require("@/EmarsysToastApp/EmarsysToast.vue"));
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SiteWideApp',
    setup(__props) {
        const showSearchApp = (0, vue_3.ref)(false);
        (0, vue_3.onMounted)(() => {
            var _a, _b;
            showSearchApp.value = !!(((_b = (_a = window.ocm) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.hasSearch) && document.getElementById("header-search-container"));
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (showSearchApp.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SearchApp_vue_1.default, { key: 0 }))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(EmarsysToast_vue_1.default),
                (0, vue_2.createVNode)(SharedToast_vue_1.default),
                (0, vue_2.createVNode)(SharedBanner_vue_1.default)
            ], 64));
        };
    }
});
